<div class="po-details">
    <div class="modal-header">
        <div class="row w-100">
            <div class="col-md-11">
                <h4 class="modal-title">Details</h4>
            </div>
            <div class="col-md-1">
                <app-print-common [rowData]="rowData" [columns]="columns"></app-print-common>
            </div>
        </div>
    </div>
    <div class="modal-body">
        <div class="card p-3 mb-2">
            <div class="row py-1">
                <div class="col-md-6" *ngFor="let colPair of columns">
                    <label class="form-label" style="font-weight: 700;">
                        {{ colPair?.header }} <span>:&nbsp; </span>
                    </label>
                    <ng-container *ngIf="colPair?.header === 'Expenses'">   
                        <ng-container *ngIf="colPair.key == 'invoiceLineItems'">
                            <span *ngFor="let wh of rowData[colPair?.key] ; let last = last">{{wh?.expense}}  <span *ngIf="!last">, </span></span>
                        </ng-container>
                    </ng-container>
                    
                    <ng-container *ngIf="colPair?.header === 'Sub Expenses'">
                        <ng-container *ngIf="colPair.key == 'expenseSubCategory'">
                            <span *ngFor="let wh of getExpenseSubCategories(rowData[colPair?.key]); let last = last">
                                {{ wh?.expenseSubCategory }}<span *ngIf="!last">, </span>
                            </span>
                        </ng-container>
                    </ng-container>
                     <ng-container *ngIf="colPair?.header === 'Vendor invoice number'" class="position-relative">
                        <span *ngFor="let exp of rowData[colPair?.key]; let last = last">
                            <!-- <a [href]="getEncodedInvoiceUrl(exp?.invoiceUrl)" class="file" target="_blank"> {{exp?.invoiceNumber}}</a><span *ngIf="!last">, </span> -->
                            <a class="file" target="_blank"> 
                                <span class="open-popup">
                                    {{exp?.invoiceNumber}}
                                    <span class="doc-popup">
                                        <!-- {{getExtType(exp?.invoiceUrl)}} -->
                                        <a *ngIf="exp?.invoiceUrl" [href]="getEncodedInvoiceUrl(exp?.invoiceUrl)" target="_blank" class="url-chip">Invoice Doc</a>
                                        <a *ngIf="exp?.supportDocUrl" [href]="getEncodedInvoiceUrl(exp?.supportDocUrl)" target="_blank" class="url-chip">Support Doc</a>
                                    </span>
                                </span>
                            </a>
                            <span *ngIf="!last">, </span>
                        </span>
                    </ng-container>

                    <ng-container *ngIf="colPair?.header == 'Approvals'">
                        <span *ngFor="let wh of rowData[colPair?.key];let columnIndex = index">
                            <div>{{columnIndex + 1}} - {{wh?.name}}
                                
                                <span [ngClass]="
                                {
                                 'primaryPill': wh?.approvalStatus === 10 ,
                                 'commentedPill': wh?.approvalStatus === 1 || wh?.approvalStatus === 4 || 
                                                 (rowData?.approvalStatus === 'PENDING_BUDGET_UPDATE' && wh?.approvalStatus === 2 && wh?.isBudgetApprover == 1),
                                 'budgetreject': wh?.approvalStatus === 5,
                                 'successPill': (wh?.approvalStatus === 2 && wh?.isBudgetApprover == 0) || wh?.approvalStatus === 9 ||
                                                 (rowData?.approvalStatus !== 'PENDING_BUDGET_UPDATE' && wh?.approvalStatus === 2 && wh?.isBudgetApprover == 1),
                                 'errorPill': wh?.approvalStatus === 3,
                                 
                                }
                                ">
                                 {{wh?.approvalStatus === 5 ? 'Budget Skipped' :  
                                 wh?.approvalStatus === 1 ? 'Pending' : 
                                 wh?.approvalStatus === 9 ? 'Partially Approved' : 
                                 wh?.approvalStatus === 8 ? 'Requested For Budget Raise' : 
                                 wh?.approvalStatus === 2 && wh?.isBudgetApprover == 0 ? 'Approved' : 
                                 rowData?.approvalStatus != 'PENDING_BUDGET_UPDATE' && wh?.approvalStatus === 2 && wh?.isBudgetApprover == 1 ? 'Budget Raised' : 
                                 rowData?.approvalStatus == 'PENDING_BUDGET_UPDATE' && wh?.approvalStatus === 2 && wh?.isBudgetApprover == 1 ? 'Requested For Budget Raise' : 
                                 wh?.approvalStatus === 3 ? 'Rejected' : 
                                 wh?.approvalStatus === 4 ? 'Commented' : '' }} </span>
                                  <ng-container *ngIf="
                                  wh?.approvalStatus === 5 ? 'Budget Skipped' :  
                                 wh?.approvalStatus === 2 && wh?.isBudgetApprover == 0 ? 'Approved' : 
                                 wh?.approvalStatus === 2 && wh?.isBudgetApprover == 1 ? 'Budget Raised' : 
                                 wh?.approvalStatus === 3 ? 'Rejected' : 
                                 wh?.approvalStatus === 4 ? 'Commented' : ''
                                   "> - {{wh?.updatedAt | CustomDatePipe: ''}}</ng-container>
                                   <!-- <ng-container *ngIf="wh?.remarks"> - {{wh?.remarks}}</ng-container> -->
                                   <ng-container *ngIf="wh?.remarks"> - 
                                    <span class="comment-text position-relative">
                                        <span class="floating-text">Remark</span>
                                        <svg width="10" height="10" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M8.09 11.6314H3.4C3.48 6.96144 4.4 6.19144 7.27 4.49144C7.6 4.29144 7.71 3.87144 7.51 3.53144C7.32 3.20144 6.89 3.09144 6.56 3.29144C3.18 5.29144 2 6.51144 2 12.3214V17.7114C2 19.4214 3.39 20.8014 5.09 20.8014H8.09C9.85 20.8014 11.18 19.4714 11.18 17.7114V14.7114C11.18 12.9614 9.85 11.6314 8.09 11.6314Z" fill="#9c9c9c"></path> <path d="M18.9086 11.6314H14.2186C14.2986 6.96144 15.2186 6.19144 18.0886 4.49144C18.4186 4.29144 18.5286 3.87144 18.3286 3.53144C18.1286 3.20144 17.7086 3.09144 17.3686 3.29144C13.9886 5.29144 12.8086 6.51144 12.8086 12.3314V17.7214C12.8086 19.4314 14.1986 20.8114 15.8986 20.8114H18.8986C20.6586 20.8114 21.9886 19.4814 21.9886 17.7214V14.7214C21.9986 12.9614 20.6686 11.6314 18.9086 11.6314Z" fill="#9c9c9c"></path> </g></svg>
                                    {{wh?.remarks}}
                                    <svg width="10" height="10" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M15.9082 12.3714H20.5982C20.5182 17.0414 19.5982 17.8114 16.7282 19.5114C16.3982 19.7114 16.2882 20.1314 16.4882 20.4714C16.6882 20.8014 17.1082 20.9114 17.4482 20.7114C20.8282 18.7114 22.0082 17.4914 22.0082 11.6714V6.28141C22.0082 4.57141 20.6182 3.19141 18.9182 3.19141H15.9182C14.1582 3.19141 12.8282 4.52141 12.8282 6.28141V9.28141C12.8182 11.0414 14.1482 12.3714 15.9082 12.3714Z" fill="#9c9c9c"></path> <path d="M5.09 12.3714H9.78C9.7 17.0414 8.78 17.8114 5.91 19.5114C5.58 19.7114 5.47 20.1314 5.67 20.4714C5.87 20.8014 6.29 20.9114 6.63 20.7114C10.01 18.7114 11.19 17.4914 11.19 11.6714V6.28141C11.19 4.57141 9.8 3.19141 8.1 3.19141H5.1C3.33 3.19141 2 4.52141 2 6.28141V9.28141C2 11.0414 3.33 12.3714 5.09 12.3714Z" fill="#9c9c9c"></path> </g></svg>
                                    </span>
                                   </ng-container>
                                </div>
                        </span>
                    </ng-container>
                    <ng-container *ngIf="colPair?.header == 'Current Approver'">
                        <span *ngFor="let wh of rowData[colPair?.key]">
                            <ng-container *ngIf="wh?.approvalStatus == 1 && wh?.viewStatus == 1">
                                {{wh.name}}
                            </ng-container>
                        </span>
                    </ng-container>
                    <ng-container *ngIf="colPair?.header == 'Status'">
                        <span> {{getFormattedValue('status')}}</span>
                    </ng-container>
                    <ng-container *ngIf="colPair?.header == 'Month of Services'">
                        {{ rowData[colPair?.key] | CustomDatePipe: 'MMMM yyyy'}}
                    </ng-container>
                    <ng-container *ngIf="colPair?.header == 'Invoice Date'">
                        {{ rowData[colPair?.key] | CustomDatePipe: 'D-M-YYYY'}}
                    </ng-container>
                    <ng-container *ngIf="colPair?.header == 'Invoice Creation Date'">
                                {{ rowData[colPair?.key] | CustomDatePipe: 'D-M-YYYY'}}
                    </ng-container>
                    <ng-container *ngIf="colPair?.header == 'Start Date'">
                        {{ rowData[colPair?.key] | CustomDatePipe: 'D-M-YYYY'}}  
                    </ng-container>
                    <ng-container>
                        <ng-container *ngIf="isArrayOfObjects(rowData[colPair?.key]); else singleValue">
                            {{ getFormattedValue(colPair?.key) }}
                        </ng-container>
                        <ng-template #singleValue>
                            <!-- <ng-container *ngIf="colPair?.header == 'Month of Services'">
                                {{ rowData[colPair?.key] | CustomDatePipe: 'MMMM yyyy'}} ddd
                            </ng-container> -->
                            <ng-container *ngIf="colPair?.header == 'Created At'">
                                {{ rowData[colPair?.key] | CustomDatePipe: 'DD-MM-YYYY'}}  
                            </ng-container>
                            <ng-container *ngIf="colPair?.header == 'Updated At'">
                                {{ rowData[colPair?.key] | CustomDatePipe: 'DD-MM-YYYY'}} 
                            </ng-container>
                            <!-- <ng-container *ngIf="colPair?.header == 'Invoice Creation Date'">
                                {{ rowData[colPair?.key] | CustomDatePipe: 'DD-MM-YYYY'}}  
                            </ng-container> -->
                            
                            <ng-container *ngIf="colPair?.header != 'Updated At' && colPair?.header != 'Created At' 
                            && colPair?.header != 'Invoice Creation Date'  && colPair?.header !=  'Month of Services'
                             && colPair?.header !=  'Start Date'">
                                {{ rowData[colPair?.key] }}
                            </ng-container>
                        </ng-template>
                    </ng-container>
                </div>
            </div>
            <div class="row py-1 d-none" *ngFor="let colPair of columnPairs">
                <div class="col-md-6" *ngIf="colPair[0]">
                    <label class="form-label" style="font-weight: 700;">
                        {{ colPair[0]?.header }} <span>:&nbsp; </span>
                    </label>
                    
                    <ng-container *ngIf="colPair[0]?.header === 'Expenses'">   
                        <ng-container *ngIf="colPair[0].key == 'invoiceLineItems'">
                            <span *ngFor="let wh of rowData[colPair[0]?.key] ; let last = last">{{wh?.expense}}  <span *ngIf="!last">, </span></span>
                        </ng-container>
                    </ng-container>
                    <ng-container *ngIf="colPair[0]?.header === 'Vendor invoice number'" class="position-relative">
                        <span *ngFor="let exp of rowData[colPair[0]?.key]; let last = last">
                            <!-- <a [href]="getEncodedInvoiceUrl(exp?.invoiceUrl)" class="file" target="_blank"> {{exp?.invoiceNumber}}</a><span *ngIf="!last">, </span> -->
                            <a class="file" target="_blank"> 
                                <span class="open-popup">
                                     <ng-container *ngIf="exp?.invoiceUrl && !exp?.supportDocUrl">
                                        <a *ngIf="exp?.invoiceUrl" [href]="getEncodedInvoiceUrl(exp?.invoiceUrl)" target="_blank" class="url-chip">{{exp?.invoiceNumber}}</a>
                                    </ng-container>
                                    <ng-container *ngIf="exp?.invoiceUrl && exp?.supportDocUrl">
                                    {{exp?.invoiceNumber}}
                                    <span class="doc-popup">
                                        <!-- {{getExtType(exp?.invoiceUrl)}} -->
                                        <a *ngIf="exp?.invoiceUrl" [href]="getEncodedInvoiceUrl(exp?.invoiceUrl)" target="_blank" class="url-chip">Invoice Doc</a>
                                        <a *ngIf="exp?.supportDocUrl" [href]="getEncodedInvoiceUrl(exp?.supportDocUrl)" target="_blank" class="url-chip">Support Doc</a>
                                    </span>
                                    </ng-container>
                                </span>
                            </a>
                            <span *ngIf="!last">, </span>
                        </span>
                    </ng-container>

                    <ng-container *ngIf="colPair[0]?.header == 'Approvals'">
                        <span *ngFor="let wh of rowData[colPair[0]?.key];let columnIndex = index">
                            <div>{{columnIndex + 1}} - {{wh?.name}}
                                
                                <span [ngClass]="
                                {
                                 'primaryPill': wh?.approvalStatus === 10 ,
                                 'commentedPill': wh?.approvalStatus === 1 || wh?.approvalStatus === 4 || 
                                                 (rowData?.approvalStatus === 'PENDING_BUDGET_UPDATE' && wh?.approvalStatus === 2 && wh?.isBudgetApprover == 1),
                                 'budgetreject': wh?.approvalStatus === 5,
                                 'successPill': (wh?.approvalStatus === 2 && wh?.isBudgetApprover == 0) || wh?.approvalStatus === 9 ||
                                                 (rowData?.approvalStatus !== 'PENDING_BUDGET_UPDATE' && wh?.approvalStatus === 2 && wh?.isBudgetApprover == 1),
                                 'errorPill': wh?.approvalStatus === 3,
                                 
                                }
                                ">
                                 {{wh?.approvalStatus === 5 ? 'Budget Skipped' :  
                                 wh?.approvalStatus === 1 ? 'Pending' : 
                                 wh?.approvalStatus === 9 ? 'Partially Approved' : 
                                 wh?.approvalStatus === 8 ? 'Requested For Budget Raise' : 
                                 wh?.approvalStatus === 2 && wh?.isBudgetApprover == 0 ? 'Approved' : 
                                 rowData?.approvalStatus != 'PENDING_BUDGET_UPDATE' && wh?.approvalStatus === 2 && wh?.isBudgetApprover == 1 ? 'Budget Raised' : 
                                 rowData?.approvalStatus == 'PENDING_BUDGET_UPDATE' && wh?.approvalStatus === 2 && wh?.isBudgetApprover == 1 ? 'Requested For Budget Raise' : 
                                 wh?.approvalStatus === 3 ? 'Rejected' : 
                                 wh?.approvalStatus === 4 ? 'Commented' : '' }} </span>
                                  <ng-container *ngIf="
                                  wh?.approvalStatus === 5 ? 'Budget Skipped' :  
                                 wh?.approvalStatus === 2 && wh?.isBudgetApprover == 0 ? 'Approved' : 
                                 wh?.approvalStatus === 2 && wh?.isBudgetApprover == 1 ? 'Budget Raised' : 
                                 wh?.approvalStatus === 3 ? 'Rejected' : 
                                 wh?.approvalStatus === 4 ? 'Commented' : ''
                                   "> - {{wh?.updatedAt | CustomDatePipe: ''}}</ng-container>
                                   <!-- <ng-container *ngIf="wh?.remarks"> - {{wh?.remarks}}</ng-container> -->
                                   <ng-container *ngIf="wh?.remarks"> - 
                                    <span class="comment-text position-relative">
                                        <span class="floating-text">Remark</span>
                                        <svg width="10" height="10" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M8.09 11.6314H3.4C3.48 6.96144 4.4 6.19144 7.27 4.49144C7.6 4.29144 7.71 3.87144 7.51 3.53144C7.32 3.20144 6.89 3.09144 6.56 3.29144C3.18 5.29144 2 6.51144 2 12.3214V17.7114C2 19.4214 3.39 20.8014 5.09 20.8014H8.09C9.85 20.8014 11.18 19.4714 11.18 17.7114V14.7114C11.18 12.9614 9.85 11.6314 8.09 11.6314Z" fill="#9c9c9c"></path> <path d="M18.9086 11.6314H14.2186C14.2986 6.96144 15.2186 6.19144 18.0886 4.49144C18.4186 4.29144 18.5286 3.87144 18.3286 3.53144C18.1286 3.20144 17.7086 3.09144 17.3686 3.29144C13.9886 5.29144 12.8086 6.51144 12.8086 12.3314V17.7214C12.8086 19.4314 14.1986 20.8114 15.8986 20.8114H18.8986C20.6586 20.8114 21.9886 19.4814 21.9886 17.7214V14.7214C21.9986 12.9614 20.6686 11.6314 18.9086 11.6314Z" fill="#9c9c9c"></path> </g></svg>
                                    {{wh?.remarks}}
                                    <svg width="10" height="10" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M15.9082 12.3714H20.5982C20.5182 17.0414 19.5982 17.8114 16.7282 19.5114C16.3982 19.7114 16.2882 20.1314 16.4882 20.4714C16.6882 20.8014 17.1082 20.9114 17.4482 20.7114C20.8282 18.7114 22.0082 17.4914 22.0082 11.6714V6.28141C22.0082 4.57141 20.6182 3.19141 18.9182 3.19141H15.9182C14.1582 3.19141 12.8282 4.52141 12.8282 6.28141V9.28141C12.8182 11.0414 14.1482 12.3714 15.9082 12.3714Z" fill="#9c9c9c"></path> <path d="M5.09 12.3714H9.78C9.7 17.0414 8.78 17.8114 5.91 19.5114C5.58 19.7114 5.47 20.1314 5.67 20.4714C5.87 20.8014 6.29 20.9114 6.63 20.7114C10.01 18.7114 11.19 17.4914 11.19 11.6714V6.28141C11.19 4.57141 9.8 3.19141 8.1 3.19141H5.1C3.33 3.19141 2 4.52141 2 6.28141V9.28141C2 11.0414 3.33 12.3714 5.09 12.3714Z" fill="#9c9c9c"></path> </g></svg>
                                    </span>
                                   </ng-container>
                                </div>
                        </span>
                    </ng-container>
                    
                    <ng-container *ngIf="colPair[0]?.header != 'Current Approver'">
                        <ng-container *ngIf="isArrayOfObjects(rowData[colPair[0]?.key]); else singleValue">
                            {{ getFormattedValue(colPair[0]?.key) }}
                        </ng-container>
                        <ng-template #singleValue>
                            <ng-container *ngIf="colPair[0]?.header == 'Created At'">
                                {{ rowData[colPair[0]?.key] | CustomDatePipe: 'DD-MM-YYYY'}}  
                            </ng-container>
                            <ng-container *ngIf="colPair[0]?.header == 'Start Date'">
                                {{ rowData[colPair[0]?.key] | CustomDatePipe: 'DD-MM-YYYY'}}  
                            </ng-container>
                            <ng-container *ngIf="colPair[0]?.header == 'Updated At'">
                                {{ rowData[colPair[0]?.key] | CustomDatePipe: 'DD-MM-YYYY'}} 
                            </ng-container>
                            <ng-container *ngIf="colPair[0]?.header != 'Updated At' && colPair[0]?.header != 'Created At' && colPair[0]?.header != 'Start Date'">
                                {{ rowData[colPair[0]?.key] }}
                            </ng-container>
                        </ng-template>
                    </ng-container>
                </div>

                <div class="col-md-6" *ngIf="colPair[1]">
                    <label class="form-label" style="font-weight: 700;">
                        {{ colPair[1]?.header }} <span>:</span>
                    </label>
                    <ng-container *ngIf="colPair[1]?.header == 'Status'">
                        <span> {{getFormattedValue('status')}}</span>
                    </ng-container>
                    
                    <ng-container *ngIf="colPair[1]?.header == 'Current Approver'">
                        <span *ngFor="let wh of rowData[colPair[1]?.key]">
                            <ng-container *ngIf="wh?.approvalStatus == 1 && wh?.viewStatus == 1">
                                {{wh.name}}
                            </ng-container>
                        </span>
                    </ng-container>
                    <ng-container *ngIf="colPair[1]?.header != 'Approvals' && colPair[1]?.header != 'Status'">
                        <ng-container *ngIf="isArrayOfObjects(rowData[colPair[1]?.key]); else singleValue2">
                            {{ getFormattedValue(colPair[1]?.key) }}
                        </ng-container>
                        <ng-template #singleValue2>
                            <ng-container *ngIf="colPair[1]?.header == 'Month of Services'">
                                {{ rowData[colPair[1]?.key] | CustomDatePipe: 'MMMM yyyy'}} 
                            </ng-container>
                            <ng-container *ngIf="colPair[1]?.header == 'Invoice Date'">
                                {{ rowData[colPair[1]?.key] | CustomDatePipe: 'D-M-YYYY'}} 
                            </ng-container>
                            <ng-container *ngIf="colPair[1]?.header == 'Created At'">
                                {{ rowData[colPair[1]?.key] | CustomDatePipe: 'DD-MM-YYYY'}}  
                            </ng-container>
                      
                            
                            <ng-container *ngIf="colPair[1]?.header == 'Updated At'">
                                {{ rowData[colPair[1]?.key] | CustomDatePipe: 'DD-MM-YYYY'}} 
                            </ng-container>
                            <!-- <ng-container *ngIf="colPair[0]?.header != 'Updated At' && colPair[0]?.header != 'Created At'"> -->

                            <ng-container *ngIf="colPair[1]?.header != 'Invoice Date' && colPair[1]?.header != 'Month of Services' && 
                            colPair[1]?.header != 'Updated At' && colPair[1]?.header != 'Created At'">
                                {{ rowData[colPair[1]?.key] }}
                            </ng-container>
                        </ng-template>
                    </ng-container>   
                    
                    <!-- <ng-container *ngIf="colPair[1]?.header === 'Upload Invoice'">
                        <ng-container *ngFor="let url of rowData[colPair[1]?.key]?.split(',')">
                            <a [href]="url.trim()" target="_blank" download>
                                <i class="pi pi-file" style="margin-right: 5px; cursor: pointer;"></i>
                            </a>
                        </ng-container>
                    </ng-container> -->
                    
            </div>
        </div>
   
        <div class="card p-3 mb-2 view" *ngIf="rowData?.invoiceLineItems?.length > 0">
            <div class="action-row">
                <div class="heading-block">
                    <label class="lineItem-title">Invoice Line Items</label>
                </div>
                <div class="action-block">
                    <ng-container *ngIf="selectedRows.length > 0 && !allSelectedRowsPending">
                        <button class="btn btn-primary downloadInvoices" (click)="approveAll('approve')">Approve All</button>
                        <button class="btn btn-primary downloadInvoices reject" (click)="approveAll('reject')">Reject All</button>
                    </ng-container>
                    <button class="btn btn-primary downloadInvoices" (click)="downloadInvoices(rowData?.invoiceLineItems)">Download Invoices</button>
                </div>
            </div>
            
            <p-table [value]="rowData?.invoiceLineItems">
                <ng-template pTemplate="header">
                    <tr>
                        <!-- <th>
                            <p-checkbox [(ngModel)]="isAllSelected" [binary]="true" (onChange)="toggleSelectAll()"></p-checkbox>
                        </th> -->
                        <th>Action</th>
                        <th>Invoice No</th>
                        <th>Amount</th>
                        <th>IGST</th>
                        <th>SGST</th>
                        <th>CGST</th>
                        <th *ngIf=" roleName == 'ROLE_SUPERUSER' || (rowData?.createdBy != this.userDetails?.id) ">Budget Amount</th>
                        <th *ngIf=" !rowData?.isHoAccount">Total Mtd</th>
                        <th>Expense Type</th>
                        <th style="width: 170px;display: block;">Expense</th>
                        <th>Sub Expense</th>
                        <th>Payment Status</th>
                        <th style="width: 150px;display: block;">Document Invoice Date</th>	
                        <!-- <th style="width: 150px;display: block;">Updated Date</th>	 -->
                        <th>Updated Date</th>
                        <th>Reference Number</th>
                        <th>Remarks</th>
                        <th style="width: 100px;">Details</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-row>
                    <tr>
                        <!-- <td>
                            <p-checkbox class="form-check-input" [(ngModel)]="row.selected" (onChange)="onRowSelect(row)" [binary]="true"></p-checkbox>
                        </td> -->
                        <td>
                            <ng-container *ngIf="isFinanceRole(roleName); else notFinanceOrNotApproved">
                                <a *ngIf="row?.lineItemApprovalStatus == 'APPROVED'  && row?.paymentStatus == 'NOT_PAID'" class="btn btn-primary" (click)="updateInvoice(row,rowData)">Update</a><br/>
                            </ng-container>
                            <ng-template #notFinanceOrNotApproved>
                                <!-- {{row?.lineItemApprovalStatus}} -->
                            </ng-template>

                            <ng-container *ngIf="isPaymentCheckRole(roleName); else isPaymentCheckRoleNot">
                                <a *ngIf="row?.referenceNumber && row?.paymentStatus == 'NOT_PAID' && row?.lineItemApprovalStatus == 'APPROVED'" class="btn btn-primary" (click)="updateInvoice(row,rowData)">Update</a><br/>
                            </ng-container>
                            <ng-template #isPaymentCheckRoleNot>
                                <!-- {{row?.lineItemApprovalStatus}} -->
                            </ng-template>
                            <!-- <ng-container *ngIf="(rowData?.approvalStatus == 'APPROVED' || rowData?.approvalStatus == 'PARTIALLY_APPROVED') && row?.lineItemApprovalStatus != 'REJECTED'">
                                <a *ngIf="row?.paymentStatus == 'NOT_PAID'" class="btn btn-primary" (click)="updateInvoice(row,rowData)">Update</a><br/>
                            </ng-container> -->
                             <!-- <ng-container *ngIf="row?.lineItemApprovalStatus">
                                {{row?.lineItemApprovalStatus}}
                            </ng-container> -->

                            <ng-container *ngIf="row?.lineItemApprovalStatus == 'REJECTED'"> 
                                <span class="errorPill">{{row?.lineItemApprovalStatus == 'REJECTED' ? 'Rejected':''}}</span>
                            </ng-container>
                            <ng-container *ngIf="row?.lineItemApprovalStatus == 'APPROVED' && !isFinanceRole(roleName) && !isPaymentCheckRole(roleName)"> 
                                <span class="successPill">{{row?.lineItemApprovalStatus == 'APPROVED' ? 'Approved':''}}</span>
                            </ng-container>
                            <ng-container *ngIf="row && row?.lineItemApprovalStatus != 'REJECTED'"> 
                            <ng-container *ngIf="currentUser?.isActionOnLineItem">
                                <ng-container *ngFor="let item of row?.approvalUser">
                                    <ng-container *ngIf="!isFinanceRole(roleName) && !isPaymentCheckRole(roleName) && !isApproved(rowData?.approvalStatus)">
                                        <span class="successPill" *ngIf="(item?.approvalStatus == 2 && (this.userDetails?.id == item?.userId)) " >Approved</span>
                                        <span class="errorPill" *ngIf="item?.approvalStatus == 3 && (this.userDetails?.id == item?.userId)">Reject</span>
                                    </ng-container>
                                    
                                    <ng-container *ngIf="item?.approvalStatus == 1 && (this.userDetails?.id == item?.userId)">
                                        <a class="btn btn-primary" (click)="approveLineItem(row,'approve')">Approve</a><br/>
                                        <a class="btn btn-primary reject" (click)="rejectLineItem(row,'reject')">Reject</a><br/>
                                    </ng-container>
                                    
                                </ng-container>
                            </ng-container>
                            </ng-container>
                        </td>
                        <td>
                            <ng-container  class="position-relative">    
                                <a class="file" target="_blank"> 
                                    <span class="open-popup">
                                        {{row?.invoiceNumber}}
                                        <span class="doc-popup">
                                            <a *ngIf="row?.invoiceUrl" [href]="getEncodedInvoiceUrl(row?.invoiceUrl)" target="_blank" class="url-chip">Invoice Doc</a>
                                            <a *ngIf="row?.supportDocUrl" [href]="getEncodedInvoiceUrl(row?.supportDocUrl)" target="_blank" class="url-chip">Support Doc</a>
                                        </span>
                                    </span>
                                </a>
                            </ng-container>
                        </td>
                        <td>{{ row?.amount }}</td>
                        <td>
                            <ng-container *ngFor="let gst of row?.invoiceLineItemExpense">
                                <span *ngIf="gst?.attributeName === 'IGST'"> {{ gst?.attributeValue}}</span>
                            </ng-container>
                        </td>
                        <td>
                            <ng-container *ngFor="let gst of row?.invoiceLineItemExpense">
                                <span *ngIf="gst?.attributeName === 'SGST'"> {{ gst?.attributeValue}}</span>
                            </ng-container>
                        </td>
                        <td>
                            <ng-container *ngFor="let gst of row?.invoiceLineItemExpense">
                                <span *ngIf="gst?.attributeName === 'CGST'"> {{ gst?.attributeValue}}</span>
                            </ng-container>
                        </td>
                        
                        <td *ngIf=" roleName == 'ROLE_SUPERUSER' || (rowData?.createdBy != this.userDetails?.id) ">
                            <ng-container >
                                {{ row?.budgetAmount }}
                            </ng-container> 
                            <!-- <ng-template #notOwner>
                            </ng-template> -->
                        </td>
                        <td *ngIf=" !rowData?.isHoAccount">{{ row?.totalMtd }}</td>
                        <td>{{ row?.expenseType }}</td>
                        <!-- <td>{{getStatusText(row?.budgetStatus) }}</td> -->
                        <td>{{ row?.expense }}</td>
                        <td>{{ row?.expenseSubCategory }}</td>
                        <td><span class="" [ngClass]=" row?.paymentStatus == 'FULL_PAID' ? 'successPill':''">{{getStatusText(row?.paymentStatus) }}</span></td>
                        <td>{{ row?.invoiceDate | CustomDatePipe: 'D-M-YYYY'}}</td>
                        <td>{{ row?.updatedAt| CustomDatePipe: ''}}</td>
                        <td>{{ row?.referenceNumber }}</td>
                        <td>{{ row?.remarks}}</td>
                        <td><a (click)="viewAttribute(row?.invoiceLineItemExpense)" class="btn btn-primary">View Attribute</a></td>
                    </tr>
                </ng-template>
            </p-table>
        </div>


        <div class="card p-3 mb-3" *ngIf="historyLists?.length>0">
            <h3 style="
          font-size: 18px;
          color: #333;
          font-weight: bold;
          ">History</h3>
            <p-timeline [value]="historyLists" align="alternate" styleClass="customized-timeline">
                <ng-template pTemplate='marker' let-event>
                    <span
                        class="flex w-8 h-8 items-center justify-center text-white rounded-full z-10 shadow-sm timelineIcon"
                        [style]="{ 'background-color': event.color }">
                        <i [class]="event.icon"></i>
                    </span>
                </ng-template>
                <ng-template pTemplate='content' let-event>
                    <p-card [header]="event.status" [subheader]="event.date">
                        <!-- <img *ngIf="event.image" [src]="'https://primefaces.org/cdn/primeng/images/demo/product/' + event.image" [alt]="event.name" width="200" class="shadow" /> -->
                        <p>
                            {{event.remarks}}
                        </p>
                        <!-- <p-button label="Read more" [text]="true" /> -->
                    </p-card>
                </ng-template>
            </p-timeline>
        </div>
    </div>
</div>




<p-dialog header="{{roleName == 'ROLE_FINANCE_CORPORATE' || 
    roleName == 'ROLE_FINANCE_MANPOWER' || roleName == 'ROLE_FINANCE_PETTYCASH' ? 'Update invoice reference number': 'Update invoice payment status'}}" [modal]="true" [(visible)]="invoiceLineItemPopUp" [style]="{ width: '25rem' }">
    <!-- <div class="svg-confirm">
       <svg fill="#000000" height="25px" width="25px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 501.333 501.333" xml:space="preserve"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <g> <path d="M250.667,0C112,0,0,112,0,250.667s112,250.667,250.667,250.667s250.667-112,250.667-250.667S389.333,0,250.667,0z M250.667,459.733c-115.2,0-209.067-93.867-209.067-209.067S135.467,41.6,250.667,41.6s209.067,93.867,209.067,209.067 S365.867,459.733,250.667,459.733z"></path> </g> </g> <g> <g> <path d="M251.733,192C240,192,230.4,201.6,230.4,213.333v172.8c0,11.733,9.6,21.333,21.333,21.333 c11.733,0,21.333-9.6,21.333-20.267V213.334C273.067,201.6,263.467,192,251.733,192z"></path> </g> </g> <g> <g> <path d="M249.6,92.8c-11.733,0-21.333,9.6-21.333,21.333V134.4c0,11.733,9.6,21.333,21.333,21.333 c11.733,0,20.267-9.6,21.333-21.333v-20.267C270.933,102.4,261.333,92.8,249.6,92.8z"></path> </g> </g> </g></svg>
   </div> -->
    <!-- <p class="p-text-secondary block mt-0 mb-2">Please confirm to proceed moving forward.</p> -->
    <div class="col-md-12" *ngIf="roleName == 'ROLE_FINANCE_CORPORATE' || 
    roleName == 'ROLE_FINANCE_MANPOWER' || roleName == 'ROLE_FINANCE_PETTYCASH'">
    <label for="" class="label">Reference number<span style="color: red;">*</span></label>
    <input type="text" class="form-control" name="approvelRemarks" [(ngModel)]="referenceNumber"
        placeholder="Please enter reference number" />
    </div>    

    <div class="col-md-12 mt-3" *ngIf="roleName == 'ROLE_FINANCE_PAYMENT_CHECKER'">
        <label for="" class="label">Payment Type<span style="color: red;">*</span></label>

        <ng-select appendTo="body" [(ngModel)]="paymentStatus"  placeholder="Select payment type">
            <ng-option value="FULL_PAID">Paid</ng-option>
            <ng-option value="NOT_PAID">Unpaid</ng-option>
        </ng-select>
    </div>
    <div class="flex justify-end gap-2 mt-4">
        <a class="btn btn-primary " (click)="updateInvoiceClick()"
            [ngClass]="referenceNumber || paymentStatus ? 'enabled':'disabled'">Update</a>
    </div>
</p-dialog>


<p-dialog header="Confirmation" [modal]="true" [(visible)]="rejectRemarksPopUpShow" [style]="{ width: '25rem' }">
    <label for="" class="label">Remarks </label>
    <input type="text" class="form-control" name="approvelRemarks" [(ngModel)]="rejectRemarks"
        placeholder="Please enter your remarks" />
    <div class="flex justify-end gap-2 mt-4">
        <a class="btn btn-primary" (click)="rejectLineItemClick()" [ngClass]="rejectRemarks ? 'enabled':'disabled'">Submit</a>
        <!-- <a class="btn btn-primary btn-denger" (click)="approveClick('reject')">Reject</a> -->
    </div>
</p-dialog>






<div class="po-details" *ngIf="hideall">
    <div class="modal-header">
        <div class="row w-100">
            <div class="col-md-11">
                <h4 class="modal-title">Details</h4>
            </div>
            <div class="col-md-1">
                <app-print-common [rowData]="rowData" [columns]="columns"></app-print-common>
            </div>
        </div>
    </div>
    <div class="modal-body">
        <div class="card p-3 mb-2">
            <div class="row py-1" *ngFor="let colPair of columnPairs">
                <div class="col-md-6" *ngIf="colPair[0]">
                    <label class="form-label" style="font-weight: 700;">
                        {{ colPair[0]?.header }} <span>:&nbsp; </span>
                    </label>
                    
                    <ng-container *ngIf="colPair[0]?.header === 'Expenses'">   
                        <ng-container *ngIf="colPair[0].key == 'invoiceLineItems'">
                            <span *ngFor="let wh of rowData[colPair[0]?.key] ; let last = last">{{wh?.expense}}  <span *ngIf="!last">, </span></span>
                        </ng-container>
                    </ng-container>
                    <ng-container *ngIf="colPair[0]?.header === 'Vendor invoice number'" class="position-relative">
                        <span *ngFor="let exp of rowData[colPair[0]?.key]; let last = last">
                            <!-- <a [href]="getEncodedInvoiceUrl(exp?.invoiceUrl)" class="file" target="_blank"> {{exp?.invoiceNumber}}</a><span *ngIf="!last">, </span> -->
                            <a class="file" target="_blank"> 
                                <span class="open-popup">
                                    {{exp?.invoiceNumber}}
                                    <span class="doc-popup">
                                        <!-- {{getExtType(exp?.invoiceUrl)}} -->
                                        <a *ngIf="exp?.invoiceUrl" [href]="getEncodedInvoiceUrl(exp?.invoiceUrl)" target="_blank" class="url-chip">Invoice Doc</a>
                                        <a *ngIf="exp?.supportDocUrl" [href]="getEncodedInvoiceUrl(exp?.supportDocUrl)" target="_blank" class="url-chip">Support Doc</a>
                                    </span>
                                </span>
                            </a>
                            <span *ngIf="!last">, </span>
                        </span>
                    </ng-container>

                    <ng-container *ngIf="colPair[0]?.header == 'Approvals'">
                        <span *ngFor="let wh of rowData[colPair[0]?.key];let columnIndex = index">
                            <div>{{columnIndex + 1}} - {{wh?.name}}
                                
                                <span [ngClass]="
                                {
                                 'primaryPill': wh?.approvalStatus === 10 ,
                                 'commentedPill': wh?.approvalStatus === 1 || wh?.approvalStatus === 4 || 
                                                 (rowData?.approvalStatus === 'PENDING_BUDGET_UPDATE' && wh?.approvalStatus === 2 && wh?.isBudgetApprover == 1),
                                 'budgetreject': wh?.approvalStatus === 5,
                                 'successPill': (wh?.approvalStatus === 2 && wh?.isBudgetApprover == 0) || wh?.approvalStatus === 9 ||
                                                 (rowData?.approvalStatus !== 'PENDING_BUDGET_UPDATE' && wh?.approvalStatus === 2 && wh?.isBudgetApprover == 1),
                                 'errorPill': wh?.approvalStatus === 3,
                                 
                                }
                                ">
                                 {{wh?.approvalStatus === 5 ? 'Budget Skipped' :  
                                 wh?.approvalStatus === 1 ? 'Pending' : 
                                 wh?.approvalStatus === 9 ? 'Partially Approved' : 
                                 wh?.approvalStatus === 8 ? 'Requested For Budget Raise' : 
                                 wh?.approvalStatus === 2 && wh?.isBudgetApprover == 0 ? 'Approved' : 
                                 rowData?.approvalStatus != 'PENDING_BUDGET_UPDATE' && wh?.approvalStatus === 2 && wh?.isBudgetApprover == 1 ? 'Budget Raised' : 
                                 rowData?.approvalStatus == 'PENDING_BUDGET_UPDATE' && wh?.approvalStatus === 2 && wh?.isBudgetApprover == 1 ? 'Requested For Budget Raise' : 
                                 wh?.approvalStatus === 3 ? 'Rejected' : 
                                 wh?.approvalStatus === 4 ? 'Commented' : '' }} </span>
                                  <ng-container *ngIf="
                                  wh?.approvalStatus === 5 ? 'Budget Skipped' :  
                                 wh?.approvalStatus === 2 && wh?.isBudgetApprover == 0 ? 'Approved' : 
                                 wh?.approvalStatus === 2 && wh?.isBudgetApprover == 1 ? 'Budget Raised' : 
                                 wh?.approvalStatus === 3 ? 'Rejected' : 
                                 wh?.approvalStatus === 4 ? 'Commented' : ''
                                   "> - {{wh?.updatedAt | CustomDatePipe: ''}}</ng-container>
                                   <!-- <ng-container *ngIf="wh?.remarks"> - {{wh?.remarks}}</ng-container> -->
                                   <ng-container *ngIf="wh?.remarks"> - 
                                    <span class="comment-text position-relative">
                                        <span class="floating-text">Remark</span>
                                        <svg width="10" height="10" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M8.09 11.6314H3.4C3.48 6.96144 4.4 6.19144 7.27 4.49144C7.6 4.29144 7.71 3.87144 7.51 3.53144C7.32 3.20144 6.89 3.09144 6.56 3.29144C3.18 5.29144 2 6.51144 2 12.3214V17.7114C2 19.4214 3.39 20.8014 5.09 20.8014H8.09C9.85 20.8014 11.18 19.4714 11.18 17.7114V14.7114C11.18 12.9614 9.85 11.6314 8.09 11.6314Z" fill="#9c9c9c"></path> <path d="M18.9086 11.6314H14.2186C14.2986 6.96144 15.2186 6.19144 18.0886 4.49144C18.4186 4.29144 18.5286 3.87144 18.3286 3.53144C18.1286 3.20144 17.7086 3.09144 17.3686 3.29144C13.9886 5.29144 12.8086 6.51144 12.8086 12.3314V17.7214C12.8086 19.4314 14.1986 20.8114 15.8986 20.8114H18.8986C20.6586 20.8114 21.9886 19.4814 21.9886 17.7214V14.7214C21.9986 12.9614 20.6686 11.6314 18.9086 11.6314Z" fill="#9c9c9c"></path> </g></svg>
                                    {{wh?.remarks}}
                                    <svg width="10" height="10" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M15.9082 12.3714H20.5982C20.5182 17.0414 19.5982 17.8114 16.7282 19.5114C16.3982 19.7114 16.2882 20.1314 16.4882 20.4714C16.6882 20.8014 17.1082 20.9114 17.4482 20.7114C20.8282 18.7114 22.0082 17.4914 22.0082 11.6714V6.28141C22.0082 4.57141 20.6182 3.19141 18.9182 3.19141H15.9182C14.1582 3.19141 12.8282 4.52141 12.8282 6.28141V9.28141C12.8182 11.0414 14.1482 12.3714 15.9082 12.3714Z" fill="#9c9c9c"></path> <path d="M5.09 12.3714H9.78C9.7 17.0414 8.78 17.8114 5.91 19.5114C5.58 19.7114 5.47 20.1314 5.67 20.4714C5.87 20.8014 6.29 20.9114 6.63 20.7114C10.01 18.7114 11.19 17.4914 11.19 11.6714V6.28141C11.19 4.57141 9.8 3.19141 8.1 3.19141H5.1C3.33 3.19141 2 4.52141 2 6.28141V9.28141C2 11.0414 3.33 12.3714 5.09 12.3714Z" fill="#9c9c9c"></path> </g></svg>
                                    </span>
                                   </ng-container>
                                </div>
                        </span>
                    </ng-container>
                    
                    <ng-container *ngIf="colPair[0]?.header != 'Current Approver'">
                        <ng-container *ngIf="isArrayOfObjects(rowData[colPair[0]?.key]); else singleValue">
                            {{ getFormattedValue(colPair[0]?.key) }}
                        </ng-container>
                        <ng-template #singleValue>
                            <ng-container *ngIf="colPair[0]?.header == 'Created At'">
                                {{ rowData[colPair[0]?.key] | CustomDatePipe: 'DD-MM-YYYY'}}  
                            </ng-container>
                            <ng-container *ngIf="colPair[0]?.header == 'Updated At'">
                                {{ rowData[colPair[0]?.key] | CustomDatePipe: 'DD-MM-YYYY'}} 
                            </ng-container>
                            <ng-container *ngIf="colPair[0]?.header != 'Updated At' && colPair[0]?.header != 'Created At'">
                                {{ rowData[colPair[0]?.key] }}
                            </ng-container>
                        </ng-template>
                    </ng-container>
                </div>

                <div class="col-md-6" *ngIf="colPair[1]">
                    <label class="form-label" style="font-weight: 700;">
                        {{ colPair[1]?.header }} <span>:</span>
                    </label>
                    <ng-container *ngIf="colPair[1]?.header == 'Status'">
                        <span> {{getFormattedValue('status')}}</span>
                    </ng-container>
                    
                    <ng-container *ngIf="colPair[1]?.header == 'Current Approver'">
                        <span *ngFor="let wh of rowData[colPair[1]?.key]">
                            <ng-container *ngIf="wh?.approvalStatus == 1 && wh?.viewStatus == 1">
                                {{wh.name}}
                            </ng-container>
                        </span>
                    </ng-container>
                    <ng-container *ngIf="colPair[1]?.header != 'Approvals' && colPair[1]?.header != 'Status'">
                        <ng-container *ngIf="isArrayOfObjects(rowData[colPair[1]?.key]); else singleValue2">
                            {{ getFormattedValue(colPair[1]?.key) }}
                        </ng-container>
                        <ng-template #singleValue2>
                            <ng-container *ngIf="colPair[1]?.header == 'Month of Services'">
                                {{ rowData[colPair[1]?.key] | CustomDatePipe: 'MMMM yyyy'}} 
                            </ng-container>
                            <ng-container *ngIf="colPair[1]?.header == 'Invoice Date'">
                                {{ rowData[colPair[1]?.key] | CustomDatePipe: 'D-M-YYYY'}} 
                            </ng-container>
                            <ng-container *ngIf="colPair[1]?.header == 'Created At'">
                                {{ rowData[colPair[1]?.key] | CustomDatePipe: 'DD-MM-YYYY'}}  
                            </ng-container>
                            <ng-container *ngIf="colPair[1]?.header == 'Updated At'">
                                {{ rowData[colPair[1]?.key] | CustomDatePipe: 'DD-MM-YYYY'}} 
                            </ng-container>
                            <!-- <ng-container *ngIf="colPair[0]?.header != 'Updated At' && colPair[0]?.header != 'Created At'"> -->

                            <ng-container *ngIf="colPair[1]?.header != 'Invoice Date' && colPair[1]?.header != 'Month of Services' && 
                            colPair[1]?.header != 'Updated At' && colPair[1]?.header != 'Created At'">
                                {{ rowData[colPair[1]?.key] }}
                            </ng-container>
                        </ng-template>
                    </ng-container>   
                    
                    <!-- <ng-container *ngIf="colPair[1]?.header === 'Upload Invoice'">
                        <ng-container *ngFor="let url of rowData[colPair[1]?.key]?.split(',')">
                            <a [href]="url.trim()" target="_blank" download>
                                <i class="pi pi-file" style="margin-right: 5px; cursor: pointer;"></i>
                            </a>
                        </ng-container>
                    </ng-container> -->
                    
            </div>
        </div>
   
        <div class="card p-3 mb-2 view" *ngIf="rowData?.invoiceLineItems?.length > 0">
            <div class="action-row">
                <div class="heading-block">
                    <label class="lineItem-title">Invoice Line Items</label>
                </div>
                <div class="action-block">
                    <ng-container *ngIf="selectedRows.length > 0 && !allSelectedRowsPending">
                        <button class="btn btn-primary downloadInvoices" (click)="approveAll('approve')">Approve All</button>
                        <button class="btn btn-primary downloadInvoices reject" (click)="approveAll('reject')">Reject All</button>
                    </ng-container>
                    <button class="btn btn-primary downloadInvoices" (click)="downloadInvoices(rowData?.invoiceLineItems)">Download Invoices</button>
                </div>
            </div>
            
            <p-table [value]="rowData?.invoiceLineItems">
                <ng-template pTemplate="header">
                    <tr>
                        <!-- <th>
                            <p-checkbox [(ngModel)]="isAllSelected" [binary]="true" (onChange)="toggleSelectAll()"></p-checkbox>
                        </th> -->
                        <th>Action</th>
                        <th>Invoice No</th>
                        <th>Amount</th>
                        <th>IGST</th>
                        <th>SGST</th>
                        <th>CGST</th>
                        <th *ngIf=" roleName == 'ROLE_SUPERUSER' || (rowData?.createdBy != this.userDetails?.id) ">Budget Amount</th>
                        <th *ngIf=" !rowData?.isHoAccount">Total Mtd</th>
                        <th>Expense Type</th>
                        <th style="width: 170px;display: block;">Expense</th>
                        <th>Payment Status</th>
                        <th style="width: 150px;display: block;">Document Invoice Date</th>	
                        <!-- <th style="width: 150px;display: block;">Updated Date</th>	 -->
                        <th>Updated Date</th>
                        <th>Reference Number</th>
                        <th>Remarks</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-row>
                    <tr>
                        <!-- <td>
                            <p-checkbox class="form-check-input" [(ngModel)]="row.selected" (onChange)="onRowSelect(row)" [binary]="true"></p-checkbox>
                        </td> -->
                        <td>
                            <ng-container *ngIf="isFinanceRole(roleName); else notFinanceOrNotApproved">
                                <a *ngIf="row?.lineItemApprovalStatus == 'APPROVED'  && row?.paymentStatus == 'NOT_PAID'" class="btn btn-primary" (click)="updateInvoice(row,rowData)">Update</a><br/>
                            </ng-container>
                            <ng-template #notFinanceOrNotApproved>
                                <!-- {{row?.lineItemApprovalStatus}} -->
                            </ng-template>

                            <ng-container *ngIf="isPaymentCheckRole(roleName); else isPaymentCheckRoleNot">
                                <a *ngIf="row?.referenceNumber && row?.paymentStatus == 'NOT_PAID' && row?.lineItemApprovalStatus == 'APPROVED'" class="btn btn-primary" (click)="updateInvoice(row,rowData)">Update</a><br/>
                            </ng-container>
                            <ng-template #isPaymentCheckRoleNot>
                                <!-- {{row?.lineItemApprovalStatus}} -->
                            </ng-template>
                            <!-- <ng-container *ngIf="(rowData?.approvalStatus == 'APPROVED' || rowData?.approvalStatus == 'PARTIALLY_APPROVED') && row?.lineItemApprovalStatus != 'REJECTED'">
                                <a *ngIf="row?.paymentStatus == 'NOT_PAID'" class="btn btn-primary" (click)="updateInvoice(row,rowData)">Update</a><br/>
                            </ng-container> -->
                             <!-- <ng-container *ngIf="row?.lineItemApprovalStatus">
                                {{row?.lineItemApprovalStatus}}
                            </ng-container> -->

                            <ng-container *ngIf="row?.lineItemApprovalStatus == 'REJECTED'"> 
                                <span class="errorPill">{{row?.lineItemApprovalStatus == 'REJECTED' ? 'Rejected':''}}</span>
                            </ng-container>
                            <ng-container *ngIf="row?.lineItemApprovalStatus == 'APPROVED' && !isFinanceRole(roleName) && !isPaymentCheckRole(roleName)"> 
                                <span class="successPill">{{row?.lineItemApprovalStatus == 'APPROVED' ? 'Approved':''}}</span>
                            </ng-container>
                            <ng-container *ngIf="row && row?.lineItemApprovalStatus != 'REJECTED'"> 
                            <ng-container *ngIf="currentUser?.isActionOnLineItem">
                                <ng-container *ngFor="let item of row?.approvalUser">
                                    <ng-container *ngIf="!isFinanceRole(roleName) && !isPaymentCheckRole(roleName) && !isApproved(rowData?.approvalStatus)">
                                        <span class="successPill" *ngIf="(item?.approvalStatus == 2 && (this.userDetails?.id == item?.userId)) " >Approved</span>
                                        <span class="errorPill" *ngIf="item?.approvalStatus == 3 && (this.userDetails?.id == item?.userId)">Reject</span>
                                    </ng-container>
                                    
                                    <ng-container *ngIf="item?.approvalStatus == 1 && (this.userDetails?.id == item?.userId)">
                                        <a class="btn btn-primary" (click)="approveLineItem(row,'approve')">Approve</a><br/>
                                        <a class="btn btn-primary reject" (click)="rejectLineItem(row,'reject')">Reject</a><br/>
                                    </ng-container>
                                    
                                </ng-container>
                            </ng-container>
                            </ng-container>
                        </td>
                        <td>
                            <ng-container  class="position-relative">    
                                <a class="file" target="_blank"> 
                                    <span class="open-popup">
                                        {{row?.invoiceNumber}}
                                        <span class="doc-popup">
                                            <a *ngIf="row?.invoiceUrl" [href]="getEncodedInvoiceUrl(row?.invoiceUrl)" target="_blank" class="url-chip">Invoice Doc</a>
                                            <a *ngIf="row?.supportDocUrl" [href]="getEncodedInvoiceUrl(row?.supportDocUrl)" target="_blank" class="url-chip">Support Doc</a>
                                        </span>
                                    </span>
                                </a>
                            </ng-container>
                        </td>
                        <td>{{ row?.amount }}</td>
                        <td>
                            <ng-container *ngFor="let gst of row?.invoiceLineItemExpense">
                                <span *ngIf="gst?.attributeName === 'IGST'"> {{ gst?.attributeValue}}</span>
                            </ng-container>
                        </td>
                        <td>
                            <ng-container *ngFor="let gst of row?.invoiceLineItemExpense">
                                <span *ngIf="gst?.attributeName === 'SGST'"> {{ gst?.attributeValue}}</span>
                            </ng-container>
                        </td>
                        <td>
                            <ng-container *ngFor="let gst of row?.invoiceLineItemExpense">
                                <span *ngIf="gst?.attributeName === 'CGST'"> {{ gst?.attributeValue}}</span>
                            </ng-container>
                        </td>
                        
                        <td *ngIf=" roleName == 'ROLE_SUPERUSER' || (rowData?.createdBy != this.userDetails?.id) ">
                            <ng-container >
                                {{ row?.budgetAmount }}
                            </ng-container> 
                            <!-- <ng-template #notOwner>
                            </ng-template> -->
                        </td>
                        <td *ngIf=" !rowData?.isHoAccount">{{ row?.totalMtd }}</td>
                        <td>{{ row?.expenseType }}</td>
                        <!-- <td>{{getStatusText(row?.budgetStatus) }}</td> -->
                        <td>{{ row?.expense }}</td>
                        <td><span class="" [ngClass]=" row?.paymentStatus == 'FULL_PAID' ? 'successPill':''">{{getStatusText(row?.paymentStatus) }}</span></td>
                        <td>{{ row?.invoiceDate | CustomDatePipe: 'D-M-YYYY'}}</td>
                        <td>{{ row?.updatedAt| CustomDatePipe: ''}}</td>
                        <td>{{ row?.referenceNumber }}</td>
                        <td>{{ row?.remarks}}</td>
                        
                    </tr>
                </ng-template>
            </p-table>
        </div>


        <div class="card p-3 mb-3" *ngIf="historyLists?.length>0">
            <h3 style="
          font-size: 18px;
          color: #333;
          font-weight: bold;
          ">History</h3>
            <p-timeline [value]="historyLists" align="alternate" styleClass="customized-timeline">
                <ng-template pTemplate='marker' let-event>
                    <span
                        class="flex w-8 h-8 items-center justify-center text-white rounded-full z-10 shadow-sm timelineIcon"
                        [style]="{ 'background-color': event.color }">
                        <i [class]="event.icon"></i>
                    </span>
                </ng-template>
                <ng-template pTemplate='content' let-event>
                    <p-card [header]="event.status" [subheader]="event.date">
                        <!-- <img *ngIf="event.image" [src]="'https://primefaces.org/cdn/primeng/images/demo/product/' + event.image" [alt]="event.name" width="200" class="shadow" /> -->
                        <p>
                            {{event.remarks}}
                        </p>
                        <!-- <p-button label="Read more" [text]="true" /> -->
                    </p-card>
                </ng-template>
            </p-timeline>
        </div>
    </div>
</div>
</div>
<div [ngClass]="attributePopUpShow ? 'show':''"  class="expenseattributePopUp">
    <div class="expenseattribute">
        <h3>View Attribute Details <a (click)="closeAttributePopup()" class="closeAttributePopup"><svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" class="p-dialog-header-close-icon p-icon" aria-hidden="true"><path d="M8.01186 7.00933L12.27 2.75116C12.341 2.68501 12.398 2.60524 12.4375 2.51661C12.4769 2.42798 12.4982 2.3323 12.4999 2.23529C12.5016 2.13827 12.4838 2.0419 12.4474 1.95194C12.4111 1.86197 12.357 1.78024 12.2884 1.71163C12.2198 1.64302 12.138 1.58893 12.0481 1.55259C11.9581 1.51625 11.8617 1.4984 11.7647 1.50011C11.6677 1.50182 11.572 1.52306 11.4834 1.56255C11.3948 1.60204 11.315 1.65898 11.2488 1.72997L6.99067 5.98814L2.7325 1.72997C2.59553 1.60234 2.41437 1.53286 2.22718 1.53616C2.03999 1.53946 1.8614 1.61529 1.72901 1.74767C1.59663 1.88006 1.5208 2.05865 1.5175 2.24584C1.5142 2.43303 1.58368 2.61419 1.71131 2.75116L5.96948 7.00933L1.71131 11.2675C1.576 11.403 1.5 11.5866 1.5 11.7781C1.5 11.9696 1.576 12.1532 1.71131 12.2887C1.84679 12.424 2.03043 12.5 2.2219 12.5C2.41338 12.5 2.59702 12.424 2.7325 12.2887L6.99067 8.03052L11.2488 12.2887C11.3843 12.424 11.568 12.5 11.7594 12.5C11.9509 12.5 12.1346 12.424 12.27 12.2887C12.4053 12.1532 12.4813 11.9696 12.4813 11.7781C12.4813 11.5866 12.4053 11.403 12.27 11.2675L8.01186 7.00933Z" fill="currentColor"></path></svg></a></h3>
        <ul>
            <li *ngFor="let attri of attributePopUpData">
                <span>{{attri?.attributeName}} : <b>{{attri?.attributeValue}}</b></span>
            </li>
        </ul>
    </div>
</div>
